import React from "react";

import styles from "../../styles/order-details.module.scss";
import { Currency } from "../utils/Currency";

// import { convertMoney } from "../utils";

export default class OrderItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  calculateItemPrice(item) {
    const props = ["items", "sizes", "extra_ingredients", "doughs", "edges"];
    let total = item.price * item.quantity;

    for (const key of props) {
      if (item[key] && item[key].length > 0) {

        let quantity = 1;
        if (key === "items" && item?.type === 'option') {
          quantity = item.quantity;
        }

        for (const subItem of item[key]) {
          total += this.calculateItemPrice(subItem) * quantity;
        }
      }
    }

    return total;
  }

  renderItem(item) {
    const selectedSize = item.sizes[0];

    return (
      <div className={styles.product}>
        <div className="d-flex align-start">
          <div className={styles.quantity}>{item.quantity || 1}x</div>
          <div className="d-flex flex-column">
            {/* {console.log(item)} */}
            {item.type === "pizza" ? (
              <>
                <span className={styles.productName}>
                  {item?.type} - {item.name}
                </span>
                <p className={styles.productSize}>MASSA:</p>
                <p className={styles.productSize}>{item.doughs[0]?.name}</p>
                <p className={styles.productSize}>SABORES:</p>
                {this.renderTitlePiiza(item)}
                <p className={styles.productSize}>BORDA:</p>
                <p className={styles.productSize}>{item.edges[0]?.name}</p>
                <p className={styles.productSize}>INGREDIENTES EXTRAS:</p>
                {item.extra_ingredients?.map(this.renderExtra.bind(this))}
              </>
            ) : (
              <>
                <p className={styles.productName}>{item.name}</p>

                {
                  <span className={styles.productSize}>
                    {selectedSize?.name}
                  </span>
                }
                {item.type === "step" &&
                  item.items.map(this.renderQuestion.bind(this))}
                {item.extra_ingredients?.map(this.renderExtra.bind(this))}
                {item.observation && this.renderObservation(item)}
              </>
            )}
          </div>
        </div>
        <p className={styles.productPrice} style={{ alignSelf: "flex-start" }}>
          {Currency.formatCurrency(this.calculateItemPrice(item) || 0)}
        </p>
      </div>
    );
  }

  renderQuestion(question) {

    const childrenQuestions = (question.items || []).map((option) => {
      const childrenQuestions = option.items || [];
      return childrenQuestions;
    }).flat(1);

    const questions = [question, ...childrenQuestions];

    return (
      <>
        {questions.map((q) => q.items.length > 0 && ( 
          <div className="d-flex flex-column">
            <span className={styles.productName}> - {q.name}</span>
            {q.items.map((option) => {
              return (
                <span className={styles.productName}>
                  {option.quantity}x {option.name}
                </span>
              );
            })}
          </div>
        ))}
      </>
    );
  }

  renderTitlePiiza(item) {
    return (
      <>
        {/* <span className={styles.productQuestion}> - {item.name}</span> */}
        {item.items.map((option) => {
          return <span className={styles.productOption}>{option.name}</span>;
        })}
      </>
    );
  }

  renderExtra(extraIngredient) {
    return (
      <div className="d-flex flex-column">
        <span className={styles.productExtra}>{extraIngredient.name}</span>
      </div>
    );
  }

  renderObservation(product) {
    return (
      <div className="d-flex flex-column">
        <span className={styles.productExtra}>Obs.: {product.observation}</span>
      </div>
    );
  }

  render() {
    const { order } = this.props;
    const {
      cart: { catalog },
    } = order;

    return (
      <div className={styles.products}>
        {catalog.items.map((i) => this.renderItem(i))}
      </div>
    );
  }
}
